import { heroData } from '@/mocks/home';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/40 via-background-50 to-accent-50/30"></div>
      <div className="absolute top-0 right-0 w-[60%] h-full opacity-[0.04] pointer-events-none">
        <div className="absolute top-10 right-10 text-[20rem] font-bold text-foreground-900 select-none font-heading">51</div>
      </div>

      <div className="relative w-full max-w-[1400px] mx-auto px-4 md:px-6 py-16 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-medium text-primary-700 bg-primary-100/80 rounded-full mb-5 whitespace-nowrap">
              {heroData.tag}
            </span>
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 leading-tight mb-4 font-heading">
              {heroData.h1}
            </h1>
            <p className="text-lg md:text-xl text-accent-600 font-medium mb-6">
              {heroData.slogan}
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-2xl lg:max-w-none">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-foreground-950 font-heading whitespace-nowrap">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.cta_primary.href}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap text-sm cursor-pointer"
              >
                {heroData.cta_primary.text}
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href={heroData.cta_secondary.href}
                className="inline-flex items-center gap-2 px-8 py-3 bg-background-100 text-foreground-700 font-medium rounded-lg hover:bg-background-200 transition-all duration-200 whitespace-nowrap text-sm cursor-pointer border border-background-300/60"
              >
                {heroData.cta_secondary.text}
                <i className="ri-arrow-down-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <img
              src="https://readdy.ai/api/search-image?query=A%20vibrant%20and%20energetic%20illustration%20of%20a%20modern%20online%20discussion%20community%20platform%20with%20hot%20topic%20cards%20floating%20in%20warm%20amber%20and%20coral%20gradients%2C%20speech%20bubbles%20with%20Chinese%20text%20placeholders%2C%20a%20dynamic%20forum-like%20atmosphere%20with%20glowing%20hot%20topic%20indicators%2C%20clean%20geometric%20abstract%20shapes%20in%20warm%20tones%2C%20modern%20UI-inspired%20design%20elements%2C%20soft%20lighting%20on%20a%20cream%20background&width=600&height=500&seq=hero-main-2026&orientation=landscape"
              alt="51大赛讨论社区 - 最火爆的大赛讨论社区"
              title="51大赛讨论社区"
              className="w-full h-auto rounded-lg object-cover"
              style={{ aspectRatio: '6/5' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}